import axios from 'axios'

export const baseURL = process.env.NEXT_PUBLIC_API_URL??"https://careermoh.api.ubuzima.rw";
console.log("baseURL =>", baseURL);

export const api = axios.create({
    baseURL,
    timeout: 10000,
})
